import Papa from 'papaparse'

export default {
  parseFile: async file => {
    const text = await file.text()
    const parsed = Papa.parse(text)
    return parsed.data
  }
}
